export default __webpack_public_path__ + "static/media/tv8.6c0dc9a6.jpeg";